import React from "react";

import Stack from "veneer/Stack";
import { ConnectivityIcon } from "veneer/SvgIcon";

import { getLastConnectedStatusMeta } from "cortex/ui/src/constant/lastConnected";
import { useAppSelector } from "cortex/ui/src/hooks";
import { deviceLastSeenSelector } from "cortex/ui/src/redux-store/last-seen-devices/selectors";
import DeviceLocalTimeBox from "cortex/ui/src/ui/device-stats/DeviceLocalTimeBox";
import { Indicator } from "cortex/ui/src/ui/indicator";
import InfoBox from "cortex/ui/src/ui/info-box";

import { Device, DeviceStatsApiResponse } from "./model";

interface StatusBoxProps {
  device: Device;
  stats: DeviceStatsApiResponse;
}

export default function StatusBox({ device, stats }: StatusBoxProps) {
  const lastSeen = useAppSelector((state) =>
    deviceLastSeenSelector(state, device),
  );
  const statusMeta = getLastConnectedStatusMeta(lastSeen);
  const uptime = stats?.stats?.network_uptime || 0;
  const statusSubText = statusMeta.tooltipSubtitle
    ? `${statusMeta.tooltipTitle} | ${statusMeta.tooltipSubtitle}`
    : statusMeta.tooltipTitle;

  return (
    <Stack direction="row" spacing={2}>
      <InfoBox
        color={statusMeta.color}
        desc={statusMeta.label}
        icon={
          <Indicator
            color={statusMeta.color}
            size="large"
            type={statusMeta.icon}
          />
        }
        subText={statusSubText}
        title="Connectivity Status"
      />
      <InfoBox
        color="purple"
        desc={`${uptime.toFixed(0)}%`}
        icon={<ConnectivityIcon size="large" />}
        title="Uptime Last 24h"
      />
      <DeviceLocalTimeBox color="teal" device={device} stats={stats} />
    </Stack>
  );
}
